import Inventory from "./Components/Inventory";

export default Inventory;
